import { Body, Checkbox } from '@assembly-js/design-system';
import { useState } from 'react';

interface Props {
  checked: boolean;
  onSaveValue: (checked: boolean) => void;
}

/** Reads as Yes or No, like the CRM table; a click swaps in the checkbox to change it. */
export const CheckboxInput = ({ checked, onSaveValue }: Props) => {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <div
        className="flex w-full min-h-8 items-center"
        // The checkbox's input is visually hidden; pressing its box would blur
        // the input and close the editor before the click lands.
        onMouseDown={(e) => e.preventDefault()}
      >
        <Checkbox
          label=""
          checked={checked}
          autoFocus
          onChange={(e) => {
            onSaveValue(e.target.checked);
            setEditing(false);
          }}
          onBlur={() => setEditing(false)}
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => setEditing(true)}
      className="flex w-full min-h-8 cursor-pointer appearance-none items-center border-0 bg-transparent px-0 text-left"
    >
      <Body size="sm">{checked ? 'Yes' : 'No'}</Body>
    </button>
  );
};
